<template>
  <div class="d-flex flex-column"
       style="width: 100%">


    <div
      v-if="items && items.length > 0"
      class="d-flex flex-column mt-3">
      <v-card v-for="item in items"
              :key="'item-'+item.book_id"
              class="d-flex mb-6" flat
              color="transparent"
      >


        <img
          @click="onSelectSubject(item.book_id)"
          class="rounded-lg align-self-start"
          style="width: 100%; cursor: pointer; object-fit: contain !important;"
          :style="isCheckout ? 'max-width: 75px' : 'max-width: 125px'"
          :src="item.image"
        >

        <div class="d-flex flex-column mt-1 ml-4" style="flex: 1">

          <div
            class="d-flex align-start">
            <!-------- DOSSIER NAME ---------->
            <div style="flex: 1">
            <span
              @click="onSelectSubject(item.book_id)"
              style="cursor: pointer; font-size: 16px; flex: 1; max-width: 200px;"
              class="font-rubik font-weight-medium">{{ item.new_subject_name || item.subject_name }}</span>
            <span v-if="item.kind === 'notes' || item.kind === 'pack'" class="d-block font-rubik" style="font-size: 13px; color: #1B8F5D">
              {{ item.kind === 'pack' ? 'Pack exàmens + apunts' : 'Apunts definitius' }}
            </span>
            </div>


            <!-------- DISCOUNT PRICE ---------->
            <div class="d-flex flex-column align-end">
                <span
                  v-if="item.oldPrice"
                  class="font-weight-regular font-rubik ml-3"
                  style="font-size: 16px !important; text-decoration: line-through"
                >
                  {{ item.oldPrice }}€
                </span>

              <!--------  PRICE ---------->
              <span
                v-if="item && item.price"
                class="font-weight-regular font-rubik font-weight-medium"
                    :style="item.oldPrice ? 'color: red; font-size: 12px !important' : ''"
                    style="font-size: 16px !important;">{{ item.price }}€</span>

            </div>
          </div>

          <div class="d-flex align-center">
            <!-------- PAGES ---------->
            <span class="mb-2 mt-1 font-rubik" style="font-size: 14px">{{ item.pages }} pàg.</span>

            <v-spacer></v-spacer>

            <!--------  PRICE ---------->
            <span
              v-if="isCheckout"
              class="font-rubik"
              style="font-size: 14px"
            >
                  {{ item.quantity }} u.
                </span>
          </div>


          <!-------- QUANTITY SELECTOR ---------->

          <div
            v-if="!isCheckout"
            class="d-flex align-center mt-0 mb-2">
            <v-card :ripple="false"
                    class="text-center justify-center pa-0 no-background-hover font-rubik mt-1"
                    style="font-size: 12px !important;"
                    small text flat
                    @click="decreaseQuantity(item.book_id)">
              ELIMINAR
            </v-card>

            <v-spacer></v-spacer>

            <div class="d-flex flex-column">
                <span style="font-size: 14px">
                  Quantitat:
                </span>
              <div class="d-flex align-center">
                <v-icon x-small
                        @click="decreaseQuantity(item.book_id)"
                        icon class="font-weight-medium mr-2" color="black">
                  {{ mdiMinus }}
                </v-icon>
                <span class="font-rubik"
                      style="font-size: 14px"
                >
                    {{ item.quantity }}</span>
                <v-icon x-small
                        @click="increaseQuantity(item.book_id)"
                        icon
                        class="font-weight-medium ml-2"
                        color="black"
                >
                  {{ mdiPlus }}
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-------- ENVIAMENT GRATIS: quant hi falta ---------->
      <free-shipping-progress :items="items"></free-shipping-progress>

      <!-------- PACK (quadern + apunts) per a qui en compra només un ---------->
      <pack-upsell :items="items"></pack-upsell>

      <!-------- SHIPPINGS ---------->
      <v-card
        v-if="shippings2 && shippings2.length && shippings2[selectedShipment] && shippings2[selectedShipment].price > 0"
        :key="refreshPrice + '-envio-price'"
        flat color="transparent"
        class="rounded-lg align-center d-flex font-rubik mt-4"
        height="36"
        style="font-size: 14px"
      >
        <span style="flex: 1">
        Envío {{ shippings2[selectedShipment].title }}
        </span>
        <span
          class="font-weight-medium"
          style="font-size: 12px">{{ shippings2[selectedShipment].price.toFixed(2) }} €</span>
      </v-card>


      <!---- TOTAL PRICE ----->
      <div class="d-flex mt-4" style="font-size: 14px">
        <span class="font-weight-medium font-rubik">Total:</span>
        <v-spacer></v-spacer>

        <!-------- DISCOUNT PRICE ---------->
        <div class="d-flex flex-column align-end">
                    <span
                      v-if="totalOldPrice() !== total()"
                      class="font-weight-regular font-rubik ml-3"
                      style="font-size: 14px !important; text-decoration: line-through"
                    >
                      {{ totalOldPrice().toFixed(2) }}€
                    </span>

          <!--------  PRICE ---------->
          <span class="font-weight-medium font-rubik"
                :style="totalOldPrice() !== total() ? 'color: red; font-size: 15px !important' : ''"
                style="font-size: 15px !important;">{{ total().toFixed(2) }}€</span>
        </div>
      </div>

      <div class="text-center mt-4">
      </div>

    </div>

  </div>
</template>

<script>

import {mdiMinus, mdiPlus} from "/src/assets/mdi.json";
import PackUpsell from "./PackUpsell.vue";
import FreeShippingProgress from "./FreeShippingProgress.vue";
import {applyFreeShipping} from "../../freeShipping";
import {addToCart, removeFromCart} from "../cart";

export default {
  name: "CheckoutItems",
  components: {PackUpsell, FreeShippingProgress},
  props: {
    items: Array,
    allBooks: Array,
    shippings: Array,
    selectedShipment: {
      type: Number,
      default: null
    },
    isCheckout: {
      type: Boolean,
      default: false
    }
  },
  metaInfo() {
    return {
      title: `Dossiers de la Selectivitat 2025`,
      meta: [
        {charset: 'utf-8'},
        {
          vmid: 'description', name: 'description',
          content: `Els dossiers de la selectivitat són el material idoni per estudiar per les PAU sense perdre el temps. Problemes classificats per temes i solucions al costat per autocorregir-te.`
        },
        {name: 'viewport', content: 'width=device-width, initial-scale=1'}
      ]
    }
  },
  async created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    if (!this.isCheckout) this.fetchShippings()
  },
  data() {
    return {
      refreshBooks: 0,
      selectedShipping: 0,
      email: null,
      mobil: null,
      dni: null,
      url: process.env.VUE_APP_AXIOS_URI,
      isUserScrolling: false,
      postalCode: null,
      sessionid: null,

      loading: false,
      loadingCode: false,
      lineItems: [],
      minShippingPrice: 0,
      refreshPrice: 0
    }
  },
  computed: {
    shippings2: {
      get() {
        return this.shippings
      },
      set(val) {
        this.$emit("update:shippings", val);
      }
    },
    cart() {
      return this.$root.cart
    },
    columns() {
      const dim = this.$vuetify.breakpoint.name;
      if (dim === 'xs')
        return 3;
      else if (dim === 'sm')
        return 4;
      else if (dim === 'md')
        return 6;
      else if (dim === 'lg')
        return 8;
      else (dim === 'xl')
      return 6;

    },
    mdiPlus() {
      return mdiPlus
    },
    mdiMinus() {
      return mdiMinus
    },
  },
  methods: {
    async submit() {
      // await this.axios.post("/shop/payment", {
      //   status: 'INCOMPLETE',
      //   dni: this.dni,
      //   email: this.email,
      //   mobile: this.mobil
      // })

      this.lineItems = [];

      for await (let item of this.items) {
        for await (let offer of item.offers) {
          const {data} = await this.axios.get(`/book/stripe-key/${item.book_id}/${offer}`)

          let idx = this.lineItems.findIndex(item => item.price === data.stripe_key)
          if (idx == -1) {
            this.lineItems.push({
              price: data.stripe_key, // The id of the one-time price you created in your Stripe dashboard
              quantity: 1,
            })
          } else {
            this.lineItems[idx].quantity++;
          }
        }
      }


      const shipping = this.shippings2[this.selectedShipping];
      const shippingPrice = Math.round(shipping.price * 100);
      if (shippingPrice > 0) {
        const {data} = await this.axios.get(`/shipping/stripe-key/${shippingPrice}/${shipping.Name}`)
        if (!data || data.length === 0) alert("Si us plau, fes una foto de la pantalla posat en contacte amb examenselectivitat per acabar la teva comanda. contacte@examenselectivitat.cat")
        this.lineItems.push({
          price: data.stripe_key, // The id of the one-time price you created in your Stripe dashboard
          quantity: 1,
        })
      }

      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
    roundNumber(number) {
      return Math.round(number * 100) / 100
    },
    total() {
      let sum = 0;
      this.items.forEach(item => {
        sum += item.quantity * item.price;
      })

      if (this.selectedShipment !== null && this.shippings2[this.selectedShipment])
        sum += this.shippings2[this.selectedShipment].price

      return this.roundNumber(sum);
    },
    totalOldPrice() {
      let sum = 0;
      this.items.forEach(item => {
        sum += item.quantity * (item.oldPrice ? item.oldPrice : item.price);
      })

      if (this.selectedShipment !== null && this.shippings2[this.selectedShipment])
        sum += this.shippings2[this.selectedShipment].price

      return this.roundNumber(sum);
    },
    toDiscount() {
      let sum = 0;
      this.items.forEach(item => {
        sum += item.quantity;
      })
      return 5 - sum;
    },
    setOffers() {

      // Set values to default
      let totalQuantity = 0;
      this.items.forEach(item => {
        item.offers = [];
        item.offerPrices = {
          offer: 0,
          normal: item.quantity
        };

        for (let i = 0; i < item.quantity; i++) {
          item.offers[i] = false;
        }
        totalQuantity += item.quantity;
      });

      // const withOffer = Math.floor(totalQuantity / 3) * 3;
      const withOffer = 0;
      // Apply offers by order
      let applied = 0;
      for (let i = 0; i < withOffer && applied < withOffer; i++) {
        for (let j = 0; j < this.items[i].quantity && applied < withOffer; j++) {
          this.items[i].offers[j] = true;
          applied++;
        }
      }

      // Merge into groups -> [0]: 8,75 or [1]: 6,95
      this.items.forEach(item => {
        const offer = item.offers.filter(o => o).length;
        item.offerPrices = {
          offer: offer,
          normal: item.offers.length - offer
        };
      });
    },
    // La galeta i el total es toquen a cart.js; CartNav / el checkout reconstrueixen `items` amb 'cart-changed'
    deleteFromCart(book) {
      removeFromCart(this, book.book_id, true)
    },
    decreaseQuantity(book_id) {
      removeFromCart(this, book_id)
    },
    increaseQuantity(book_id) {
      addToCart(this, book_id)
    },
    handleScroll(event) {
      this.isUserScrolling = (window.scrollY > 80);
    },
    async onSelectSubject(book_id) {
      this.$router.push({path: '/dossiers-selectivitat/book/' + book_id})
    },
    async fetchShippings() {
      this.loadingCode = true;
      let pages = 0;
      let price = 0;
      let totalQuantity = 0;
      this.items.forEach(item => {
        price += (item.pages * 0.02 + 0.08) * item.quantity;
        pages += item.pages * item.quantity;
        totalQuantity += item.quantity;
      })

      pages = Math.round(pages / 2);

      const {data} = await this.axios.get(`/shop/shipping/${pages}`)
      this.shippings2 = await applyFreeShipping(data, this.items)
      this.$emit("update:selectedShipment", 0)
      this.refreshPrice++


      this.minShippingPrice = Math.min(...this.shippings2.map(s => s.price))


      this.loadingCode = false;
    },
    offerImage() {
      return this.url + '/images/other/OfertaBooklets.png'
    },
    offerImageSm() {
      return this.url + '/images/other/OfertaBooklets_sm.png'
    }
  },
  watch: {
    async items(val) {
      // Al checkout l'enviament el calcula CheckOutPage (amb la província i l'opció triada)
      if (!this.isCheckout) await this.fetchShippings()
    }
  }
}
</script>

<style scoped>
.post-code-input >>> label {
  font-size: 14px !important;
}

.post-code-input >>> .v-label--active {
  top: -5px !important;
}
</style>
